import React, { useState, useMemo } from 'react';
import styles from './ModalDropdown.module.css';
import { ArrowRightTriangleIcon } from 'assets/icons';
import useTheme from 'config/useTheme';

const normalizeOption = (option) => {
    return typeof option === 'object' && option !== null
        ? option
        : { value: option, label: option };
};

const ModalDropdown = ({ title, options = [], setOption = () => { } }) => {
    const { dark } = useTheme();
    const [opened, setOpened] = useState(false);

    const normalizedOptions = useMemo(() => options.map(normalizeOption), [options]);

    const currentLabel = useMemo(() => {
        const match = normalizedOptions.find(opt => opt.value === title);
        return match ? match.label : title;
    }, [title, normalizedOptions]);

    return (
        <div className={`${styles.modal_dropdown} ${opened ? styles.opened : ''} ${dark ? styles.dark : ''}`}>
            <button onClick={() => setOpened(!opened)}>
                <span>{currentLabel || 'Select type'}</span>
                <ArrowRightTriangleIcon />
            </button>
            {opened && normalizedOptions.length > 0 && (
                <div className={styles.modal_dropdown_options}>
                    {normalizedOptions.map((option, index) => (
                        <button
                            key={option.value || index}
                            onClick={() => {
                                setOption(option.value);
                                setOpened(false);
                            }}
                        >
                            <span>{option.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ModalDropdown;
